import React, { useState } from "react";
import { useSelector } from "react-redux";
import Navbar from "./Navbar";
import { TMDB_IMG_URL } from "../utils/constant";
import { Link } from "react-router-dom";
import searchImg from "../assets/movie-pic.jpeg";
import Footer from "./Footer";

const SearchResults = () => {
  const movies = useSelector((state) => state.searchMovies.searchResults || []); // Access search results from Redux
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10; // Rows per page

  // Calculate indices for pagination
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = movies.slice(indexOfFirstRow, indexOfLastRow); // Sliced rows for the current page
  const totalPages = Math.ceil(movies.length / rowsPerPage); // Total number of pages

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <>
      <Navbar />
      <section className="">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-6">
            {currentRows.length > 0 ? (
              currentRows.map((movie) => (
                <div key={movie.id} className="movie-card">
                  <Link to={`/single/${movie.id}`} className="block">
                    <img
                      src={
                        movie.poster_path
                          ? `${TMDB_IMG_URL}${movie.poster_path}`
                          : searchImg
                      }
                      alt={movie.title}
                      className="w-full h-[300px] object-cover"
                    />
                    <h6 className="text-center text-sm pt-2 text-white">
                      {movie.title}
                    </h6>
                    <p className="text-center pt-1 pb-4 text-white">
                      Rating: {movie.vote_average || "N/A"}
                    </p>
                  </Link>
                </div>
              ))
            ) : (
              <p className="text-white text-center col-span-full">
                No movies found. Please try searching for another movie.
              </p>
            )}
          </div>
        </div>
      </section>

      {/* Pagination Controls */}
      <div className="flex justify-center mt-4 mb-10">
        <nav className="flex items-center space-x-2">
          {/* Previous Button */}
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className={`px-4 py-2 border rounded-[30px] ${
              currentPage === 1
                ? "text-gray-300 border-gray-300 cursor-not-allowed"
                : "text-red-500 hover:bg-gray-100 border-gray-400"
            }`}
          >
            Previous
          </button>

          {/* Page Numbers */}
          {Array.from({ length: totalPages }, (_, index) => (
            <button
              key={index}
              onClick={() => handlePageChange(index + 1)}
              className={`px-4 py-2 rounded-[30px] ${
                currentPage === index + 1
                  ? "bg-red-500 text-white"
                  : "bg-gray-200 text-gray-700 hover:bg-gray-300"
              }`}
            >
              {index + 1}
            </button>
          ))}

          {/* Next Button */}
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className={`px-4 py-2 border rounded-[30px] ${
              currentPage === totalPages
                ? "text-gray-300 border-gray-300 cursor-not-allowed"
                : "text-red-500 hover:bg-gray-100 border-gray-400"
            }`}
          >
            Next
          </button>
        </nav>
      </div>
      <Footer/>
    </>
  );
};

export default SearchResults;
